import { HIGHLY_SENSITIVE, SENSITIVE } from '../constants/SensitiveScopes';
export const isSensitiveScope = scopeName => scopeName.includes(SENSITIVE);
export const isHighlySensitiveScope = scopeName => scopeName.includes(HIGHLY_SENSITIVE);